/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateNotificationDto } from '../models/work-create-notification-dto';
import { WorkNotification } from '../models/work-notification';
import { WorkUpdateNotificationDto } from '../models/work-update-notification-dto';

@Injectable({ providedIn: 'root' })
export class WorkNotificationsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `notificationsV2ControllerFindByNewsId()` */
  static readonly NotificationsV2ControllerFindByNewsIdPath = '/v2/notifications/byNewsId/{id}';

  /**
   * Required permissions: notifications:read, notifications:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationsV2ControllerFindByNewsId()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationsV2ControllerFindByNewsId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkNotification>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNotificationsV2Service.NotificationsV2ControllerFindByNewsIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkNotification>>;
      })
    );
  }

  /**
   * Required permissions: notifications:read, notifications:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationsV2ControllerFindByNewsId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationsV2ControllerFindByNewsId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkNotification>> {
    return this.notificationsV2ControllerFindByNewsId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkNotification>>): Array<WorkNotification> => r.body)
    );
  }

  /** Path part for operation `notificationsV2ControllerFindByEventId()` */
  static readonly NotificationsV2ControllerFindByEventIdPath = '/v2/notifications/byEventId/{id}';

  /**
   * Required permissions: notifications:read, notifications:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationsV2ControllerFindByEventId()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationsV2ControllerFindByEventId$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkNotification>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNotificationsV2Service.NotificationsV2ControllerFindByEventIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkNotification>>;
      })
    );
  }

  /**
   * Required permissions: notifications:read, notifications:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationsV2ControllerFindByEventId$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationsV2ControllerFindByEventId(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkNotification>> {
    return this.notificationsV2ControllerFindByEventId$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkNotification>>): Array<WorkNotification> => r.body)
    );
  }

  /** Path part for operation `notificationsV2ControllerCreate()` */
  static readonly NotificationsV2ControllerCreatePath = '/v2/notifications';

  /**
   * Required permissions: notifications:create, notifications:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationsV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notificationsV2ControllerCreate$Response(
    params: {
      body: WorkCreateNotificationDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkNotification>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNotificationsV2Service.NotificationsV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkNotification>;
      })
    );
  }

  /**
   * Required permissions: notifications:create, notifications:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationsV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notificationsV2ControllerCreate(
    params: {
      body: WorkCreateNotificationDto
    },
    context?: HttpContext
  ): Observable<WorkNotification> {
    return this.notificationsV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkNotification>): WorkNotification => r.body)
    );
  }

  /** Path part for operation `notificationsV2ControllerDelete()` */
  static readonly NotificationsV2ControllerDeletePath = '/v2/notifications/{id}';

  /**
   * Required permissions: notifications:delete, notifications:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationsV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationsV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNotificationsV2Service.NotificationsV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: notifications:delete, notifications:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationsV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  notificationsV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.notificationsV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `notificationsV2ControllerUpdate()` */
  static readonly NotificationsV2ControllerUpdatePath = '/v2/notifications/{id}';

  /**
   * Required permissions: notifications:update, notifications:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `notificationsV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notificationsV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateNotificationDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkNotification>> {
    const rb = new RequestBuilder(this.rootUrl, WorkNotificationsV2Service.NotificationsV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkNotification>;
      })
    );
  }

  /**
   * Required permissions: notifications:update, notifications:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `notificationsV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  notificationsV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateNotificationDto
    },
    context?: HttpContext
  ): Observable<WorkNotification> {
    return this.notificationsV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkNotification>): WorkNotification => r.body)
    );
  }

}
